/**
 * Challenge Wind-Down Schedule
 *
 * All times are PST (UTC-8). Feb/early-Mar are non-DST.
 * PST 11:59 PM = next day UTC 08:00.
 */
export const WIND_DOWN = {
  /** Submission deadline: 2/23 PST 11:59 PM */
  SUBMISSION_DEADLINE: new Date('2026-02-24T08:00:00.000Z'),
  /** Reward collection deadline: 3/1 PST 11:59 PM (existing 7-day collection handles this; no explicit check needed yet) */
  REWARD_DEADLINE: new Date('2026-03-02T08:00:00.000Z'),
  /** Exchange deadline: 3/5 PST 11:59 PM */
  EXCHANGE_DEADLINE: new Date('2026-03-06T08:00:00.000Z'),
} as const;

/** 표시용 날짜: 마감 직전(실제 마지막 날)을 보여줌 */
export const WIND_DOWN_DISPLAY = {
  SUBMISSION_DEADLINE: new Date(WIND_DOWN.SUBMISSION_DEADLINE.getTime() - 1),
  EXCHANGE_DEADLINE: new Date(WIND_DOWN.EXCHANGE_DEADLINE.getTime() - 1),
} as const;

export const isSubmissionClosed = () =>
  process.env.NEXT_PUBLIC_BYPASS_WIND_DOWN === 'true'
    ? false
    : new Date() >= WIND_DOWN.SUBMISSION_DEADLINE;
export const isExchangeClosed = () => new Date() >= WIND_DOWN.EXCHANGE_DEADLINE;
